<template>
  <v-card class="pa-5 ml-10 mr-10 mt-5">
    <v-card-title>Module</v-card-title>
    <v-card-text>
      <v-data-table
        hide-default-footer
        items-per-page="20"
        class="border-table"
        density="compact"
        :headers="headers"
        hide-no-data
        item-value="id"
        :items="modulesValue">
        <template v-slot:item.active="{ item }">
          <template v-if="listOnly"></template>
          <template v-else>
            <v-checkbox
              :disabled="!props.allowedEdit"
              :data-cy="'module-' + item.id + '-active'"
              :model-value="item.active"
              @change="onModuleActiveChange(item.id, $event)"
              hide-details>
            </v-checkbox>
            <span v-if="monthEnd & item.id"
              >(Noch bis zum Ende des Monats)</span
            >
          </template>
        </template>
      </v-data-table>
    </v-card-text>
    <v-card-text>
      <v-row class="mt-5">
        <v-col
          cols="6"
          style="display: grid; justify-content: end"
          >Monatliche Kosten</v-col
        >
        <v-col
          cols="6"
          style="display: grid; justify-content: end">
          <s v-if="props.modules !== 0 && oldMonthlyCost !== monthlyCost"
            >{{ oldMonthlyCost }} €</s
          >
          {{ monthlyCost }} €
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions v-if="showSaveButton">
      <v-spacer />
      <v-btn
        v-if="allowedEdit"
        @click="saveModules"
        >Speichern</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script lang="ts" setup>
import { useConfirm, useSnackbar } from "vuetify-use-dialog";
import { onMounted } from "vue";
import { computed } from "vue";
import { ref } from "vue";
import { useTranslation } from "i18next-vue";
import { Ref } from "vue";
import { toRaw } from "vue";
import { useMainStore } from "@/stores/mainStore";

const createConfirm = useConfirm();
const createSnackbar = useSnackbar();
const { t } = useTranslation();
const mainStore = useMainStore();

const emit = defineEmits(["moduleUpdate"]);

const props = withDefaults(
  defineProps<{
    modules: number;
    monthEnd: number;
    showSaveButton: boolean;
    allowedEdit: boolean;
    listOnly: boolean;
  }>(),
  {
    showSaveButton: true,
    allowedEdit: true,
    listOnly: false
  }
);

defineExpose({
  getInfos
});

const headers: any = computed(() => {
  const heads = [
    {
      title: "Modul",
      align: "start",
      sortable: false,
      key: "module",
      width: "25%"
    },
    {
      title: "Beschreibung",
      align: "start",
      sortable: false,
      key: "description",
      width: "25%"
    },
    {
      title: "Aktiv",
      key: "active",
      sortable: false,
      width: "25%"
    },
    {
      title: "Preis pro Monat",
      key: "price",
      sortable: false,
      align: "end",
      value: (item) => {
        console.log(
          item.module,
          item.price,
          Math.floor(item.price) / 100 + " €"
        );
        return Math.floor(item.price) / 100 + " €";
      },
      width: "25%"
    }
  ];

  // if (props.userCount > 1) {
  //   heads.push({
  //     title: "Preis pro Monat (Gesamt)",
  //     key: "priceTotal",
  //     sortable: false,
  //     align: "end",
  //     value: (item) => Math.floor(item.price * props.userCount) / 100 + " €",
  //     width: "25%"
  //   });
  // }

  return heads;
});

const model = defineModel<number>();
const modulesValue: Ref<
  Array<{
    id: number;
    active: boolean;
    slots: string;
    price: number;
    description: string;
    name: string;
  }>
> = computed(() => {
  let result = [];
  for (const module of mainStore.modules) {
    module.active = !!(module.id & model.value);
    result.push(module);
  }
  return result;
});

function getInfos() {
  return {
    monthlyCost: monthlyCost.value,
    additionalCharge: additionalCharge.value,
    removedModules: modulesRemoved.value
      .map((module) => module.module)
      .join(", "),
    modulesRemoved: modulesRemoved.value
  };
}

function saveModules() {
  // saveModules
  console.log("saveModules");

  // TODO save on server
  // payment for remaining days of the month
  //
  createConfirm({
    dialogProps: { width: 400 },
    cardProps: { color: "warning" },
    title: t(`actions.confirmation.change-licence.title`),
    content:
      t(`actions.confirmation.change-licence.content`, {
        newPrice: monthlyCost.value
      }) +
      (additionalCharge.value
        ? t(
            `actions.confirmation.change-licence.module-added`,
            additionalCharge.value
          )
        : "") +
      (modulesRemoved.value.length
        ? t(`actions.confirmation.change-licence.module-removed`, {
            removedModules: modulesRemoved.value
              .map((module) => module.module)
              .join(", ")
          })
        : ""),
    cardTextProps: { style: { "white-space": "pre-wrap" } },
    confirmationText: t(`actions.confirmation.change-licence.confirm`),
    cancellationText: t(`actions.confirmation.change-licence.cancel`)
    // confirmationButtonProps: { color: "warning" }
  }).then((confirm) => {
    if (confirm) {
      emit("moduleUpdate", model.value);
      createSnackbar({
        text: t("actions.deleted"),
        showCloseButton: false,
        snackbarProps: { color: "error", timeout: 1000 }
      });
    }
  });
}

const oldMonthlyCost = computed(() => {
  return Object.values(MODULES).reduce((acc, module) => {
    if (module.id & props.modules) {
      acc += Number(module.price / 100) * props.userCount;
    }
    return acc;
  }, 0);
});

const monthlyCost = computed(() => {
  return (
    Math.floor(
      modulesValue.value.reduce((acc, module) => {
        console.log("monthlyCosts", module);
        if (module.active) {
          console.log(true, acc);
          acc += Number(module.price); // * props.userCount;
        }
        return acc;
      }, 0)
    ) / 100
  );
});

const modulesAdded = computed(() => {
  return modulesValue.value
    .filter(
      (m) => m.active && !(m.id & props.modules) && !(m.id & props.monthEnd)
    )
    .map((module) => toRaw(module));
});

const additionalCharge = computed(() => {
  if (modulesAdded.value.length) {
    const now = new Date();
    const monthDays = new Date(
      now.getFullYear(),
      now.getMonth() + 1,
      0
    ).getDate();
    const remainingDays = monthDays - now.getDate() + 1;
    return {
      remainingDays,
      additionalPrice:
        Math.floor(
          modulesAdded.value.reduce((acc, module) => {
            acc += Number(module.price / 100); // * props.userCount;
            return acc;
          }, 0) *
            (remainingDays / monthDays) *
            100
        ) / 100,
      addedModules: modulesAdded.value.map((module) => module.module).join(", ")
    };
  }
  return null;
});

const modulesRemoved = computed(() => {
  return modulesValue.value.filter((m) => !m.active && m.id & props.modules);
});

function onModuleActiveChange(id, event) {
  model.value = model.value ^ parseInt(id);
}
</script>
